/**
 * Convert "14:30" -> "2:30 PM" ;  "09:05" -> "9:05 AM"
 * Handles empty/bad input gracefully.
 */
export function format12Hour(time24) {
  if (!time24 || typeof time24 !== "string") return "";
  const parts = time24.split(":");
  if (parts.length < 2) return time24;
  let h = parseInt(parts[0], 10);
  const m = parts[1].padStart(2, "0");
  if (isNaN(h)) return time24;
  const period = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${m} ${period}`;
}
